export default __webpack_public_path__ + "static/media/header3.d3f7a802.jpg";